var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 191,
    viewBox: "0 0 12 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4974_243623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91845 185.368L5.91846 13.001L5.25398 13.001L5.25397 185.368L5.91845 185.368Z",
    fill: "url(#paint0_linear_4974_243623)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39795 21.3923L6.39795 16.9648L4.88099 16.9648L4.88099 21.3923L6.39795 21.3923Z",
    fill: "url(#paint1_linear_4974_243623)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58203 17.8889L8.58203 6.20508L2.73137 6.20508L2.73137 17.8889L8.58203 17.8889Z",
    fill: "url(#paint2_radial_4974_243623)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66003e-06 6.73209C1.52344e-06 9.99115 2.53381 12.6331 5.65942 12.6331C8.78504 12.6331 11.3188 9.99115 11.3188 6.73209C11.3188 3.47304 8.78504 0.831055 5.65942 0.831054C2.53381 0.831054 1.79662e-06 3.47303 1.66003e-06 6.73209Z",
    fill: "url(#paint3_radial_4974_243623)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72523 170.157L4.72523 174.585L6.24219 174.585L6.24219 170.157L4.72523 170.157Z",
    fill: "url(#paint4_linear_4974_243623)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84514 173.772L2.84514 185.456L8.6958 185.456L8.6958 173.772L2.84514 173.772Z",
    fill: "url(#paint5_radial_4974_243623)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.109379 184.928C0.109378 188.187 2.64319 190.829 5.7688 190.829C8.89441 190.829 11.4282 188.187 11.4282 184.928C11.4282 181.669 8.89441 179.027 5.7688 179.027C2.64319 179.027 0.109379 181.669 0.109379 184.928Z",
    fill: "url(#paint6_linear_4974_243623)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4974_243623",
    x: 3.78715,
    y: 11.5342,
    width: 3.59806,
    height: 175.301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.733377
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.929412 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4974_243623"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4974_243623",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4974_243623",
    x1: 5.5846,
    y1: 13.001,
    x2: 5.58459,
    y2: 185.368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#502EEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5B57F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#698CF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#74B6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#7CD4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#81E6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#83EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#81E6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#7CD5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#75B9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#6A91F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#5D5FF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502EEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4974_243623",
    x1: 5.63947,
    y1: -0.169789,
    x2: 5.63947,
    y2: 4.35021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#00007C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0A4094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#104A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#2164B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D76C2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4974_243623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.64943 16.1855) rotate(90) scale(8.27362 2.9359)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D76C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#2164B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#104A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0A4094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00007C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4974_243623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.39355 8.74642) rotate(90) scale(3.60619 3.45854)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E60AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#104A9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#0A4094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00007C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4974_243623",
    x1: 6.91315,
    y1: 170.806,
    x2: 4.08464,
    y2: 173.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559BE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#4F94E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#4081CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#2763B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#0A4094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00007C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4974_243623",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.02086 174.202) rotate(90) scale(9.88914 2.94011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#2D76C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#286EBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1B5AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0A4094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00007C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4974_243623",
    x1: 6.65369,
    y1: 179.098,
    x2: 4.73366,
    y2: 190.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D96D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5790D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#2D65AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#134A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#0A4094"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00007C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.bf3c17785fea74b64788a228c19f5520.svg";
export { ForwardRef as ReactComponent };